import { Link, Section, Text } from '@react-email/components';

import React from 'react';

const Footer = () => {
    return (
        <Section style={styles.container}>
            {/* Questions & Support Email */}
            <Text style={styles.text}>
                Questions?{' '}
                <a href={`mailto:support@beseenhealth.com`} style={styles.email}>
                    support@beseenhealth.com
                </a>

                {/* <Link href="{{UNSUBSCRIBE_URL}}" style={styles.unsubscribeText}>
                    Unsubscribe
                </Link> */}
            </Text>

            {/* Legal Text */}
            {/* <Section style={styles.legalText}>
                <Text>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Adipiscing phasellus fringilla proin
                    aliquam elementum eget enim curabitur. Molestie proin in massa est semper maecenas commodo in. Ac in
                    ipsum sit vel pharetra enim in. Nunc nec sagittis, ut varius et vestibulum aenean in. Ac faucibus
                    netus justo, est. Egestas morbi mollis vitae aliquet.
                </Text>
                <Text>
                    Dui nulla facilisi sed consectetur blandit et. Elementum, dictum pellentesque turpis interdum
                    consequat ut integer magna. Turpis tincidunt ultricies lorem interdum leo. Id aliquam magna viverra
                    adipiscing auctor. Scelerisque bibendum id gravida in. Tellus tincidunt eleifend cursus in. Risus
                    purus iaculis neque imperdiet sit pulvinar enim nunc, hendrerit. Accumsan diam dolor in vel tortor.
                </Text>
            </Section> */}

            {/* Unsubscribe Link */}
            {/* <Section style={styles.unsubscribe}>
                <Link href="{{UNSUBSCRIBE_URL}}" style={styles.unsubscribeText}>
                    Unsubscribe
                </Link>
            </Section> */}
        </Section>
    );
};

const styles = {
    container: {
        textAlign: 'center',
        marginTop: '40px',
        paddingTop: '20px',
    },
    text: {
        color: '#666',
        marginRight: '5px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    email: {
        color: '#ff5f39',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    legalText: {
        color: '#929ca8',
        fontSize: '10px',
        textAlign: 'justify',
        marginTop: '20px',
        borderTop: '1px solid #E5E5E5',
        borderBottom: '1px solid #E5E5E5',
    },
    unsubscribe: {
        marginTop: '20px',
        textAlign: 'center',
    },
    unsubscribeText: {
        color: '#ff5f39',
        fontSize: '12px',
        fontWeight: 'bold',
        textDecoration: 'none',
        marginLeft:'10px',
    },
};

export default Footer;
